export default [
  {
    path: "/following",
    props: true,
    component: () => import("../Main.vue")
  }
]
